import { combineReducers } from 'redux';
import _omit from 'lodash/omit';

import errors from './errors';

import {
  ACTION_ADD_SITES,
  ACTION_LOAD_SITES_WITH_ALIASES__REQUEST,
  ACTION_LOAD_SITES_WITH_ALIASES__SUCCESS,
  ACTION_LOAD_SITES_WITH_ALIASES__FAIL,
  ACTION_LOAD_ACTIVE_SITES__REQUEST,
  ACTION_LOAD_ACTIVE_SITES__SUCCESS,
  ACTION_LOAD_ACTIVE_SITES__FAIL,
  ACTION_DELETE_SITE__REQUEST,
  ACTION_DELETE_SITE__SUCCESS,
  ACTION_DELETE_SITE__FAIL,
  ACTION_SET_CURRENT_SITE_ID,
} from '../actionTypes';

import {
  ACTION_CREATE_SITE__SUCCESS,
  ACTION_EDIT_SITE__SUCCESS,
} from '../../siteBuilder/actionTypes';


const byId = (state = {}, action) => {
  switch (action.type) {
    case ACTION_ADD_SITES:
      return { ...state, ...action.payload.sites };

    case ACTION_DELETE_SITE__SUCCESS:
      return _omit(state, action.payload.siteId);

    case ACTION_CREATE_SITE__SUCCESS:
    case ACTION_EDIT_SITE__SUCCESS:
      return { ...state, [action.payload.site.id]: action.payload.site };

    default:
      return state;
  }
};

const idsWithAliases = (state = [], action) => {
  switch (action.type) {
    case ACTION_LOAD_SITES_WITH_ALIASES__REQUEST:
    case ACTION_LOAD_SITES_WITH_ALIASES__FAIL:
      return [];

    case ACTION_LOAD_SITES_WITH_ALIASES__SUCCESS:
      return action.payload.siteIds;

    default:
      return state;
  }
};

const idsActive = (state = [], action) => {
  switch (action.type) {
    case ACTION_LOAD_ACTIVE_SITES__REQUEST:
    case ACTION_LOAD_ACTIVE_SITES__FAIL:
      return [];

    case ACTION_LOAD_ACTIVE_SITES__SUCCESS:
      return action.payload.siteIds;

    default:
      return state;
  }
};

const isSitesWithAliasesLoading = (state = false, action) => {
  switch (action.type) {
    case ACTION_LOAD_SITES_WITH_ALIASES__REQUEST:
      return true;

    case ACTION_LOAD_SITES_WITH_ALIASES__SUCCESS:
    case ACTION_LOAD_SITES_WITH_ALIASES__FAIL:
      return false;

    default:
      return state;
  }
};

const isActiveSitesLoading = (state = false, action) => {
  switch (action.type) {
    case ACTION_LOAD_ACTIVE_SITES__REQUEST:
      return true;

    case ACTION_LOAD_ACTIVE_SITES__SUCCESS:
    case ACTION_LOAD_ACTIVE_SITES__FAIL:
      return false;

    default:
      return state;
  }
};

const isSiteBeingDeleted = (state = {}, action) => {
  switch (action.type) {
    case ACTION_DELETE_SITE__REQUEST:
      return { ...state, [action.payload.siteId]: true };

    case ACTION_DELETE_SITE__SUCCESS:
    case ACTION_DELETE_SITE__FAIL:
      return _omit(state, action.payload.siteId);

    default:
      return state;
  }
};

const currentSiteId = (state = null, action) => {
  switch (action.type) {
    case ACTION_SET_CURRENT_SITE_ID:
      return action.payload.siteId;

    default:
      return state;
  }
};

export default combineReducers({
  byId,
  idsWithAliases,
  idsActive,
  isSitesWithAliasesLoading,
  isActiveSitesLoading,
  isSiteBeingDeleted,
  currentSiteId,
  errors,
});
